import React from "react";
import { Navigate } from "react-router-dom";

export const DashboardGridWithChat = () => {
  return <Navigate to="/sherpa" replace />;
};
